const API_URL = "https://pasesmedicoshes.com/api";
export { API_URL };
